import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import moment from 'moment'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { NavLink as RouterLink } from 'react-router-dom'
import firebase from 'firebase/app'
import PropTypes from 'prop-types'
import {
    Box,
    Button,
    Card,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
    Tooltip,
    CircularProgress,
    makeStyles,
    Chip
} from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'

const useStyles = makeStyles(() => ({
    root: {},
    actions: {
        justifyContent: 'flex-end'
    }
}))

const LatestUsers = ({ className, ...rest }) => {
    const classes = useStyles()
    // const [orders] = useState(data);
    const [users, setUsers] = useState()

    useEffect(() => {
        firebase
            .firestore()
            .collection('users')
            .orderBy('metadata.createDate', 'desc')
            .limit(10)
            .get()
            .then((docs) => {
                const _users = []
                if (!docs.empty) {
                    docs.forEach((user) => {
                        const _user = user.data()
                        _users.push({ ..._user, id: user.id })
                    })
                }

                setUsers(_users)
            })
    }, [])

    return (
        <Card className={clsx(classes.root, className)} {...rest}>
            <CardHeader title="Latest Users" />
            <Divider />
            <PerfectScrollbar>
                <Box minWidth={800}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Location</TableCell>
                                <TableCell sortDirection="desc">
                                    <Tooltip enterDelay={300} title="Sort">
                                        <TableSortLabel active direction="desc">
                                            Registration Date
                                        </TableSortLabel>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users ? (
                                users.map((user) => (
                                    <TableRow hover key={user.id}>
                                        <TableCell>
                                            {user.name}
                                            {'  '}
                                            {user.surname}
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                color={
                                                    user.disabled === false
                                                        ? 'primary'
                                                        : 'default'
                                                }
                                                label={
                                                    user.disabled === false
                                                        ? 'active'
                                                        : 'disable'
                                                }
                                                size="small"
                                            />
                                            {user.banned ? (
                                                <Chip
                                                    style={{
                                                        backgroundColor: 'red',
                                                        marginLeft: 4
                                                    }}
                                                    label="banned"
                                                    size="small"
                                                />
                                            ) : null}
                                        </TableCell>
                                        <TableCell>{user.email}</TableCell>
                                        <TableCell>
                                            {user.coordinatesName}
                                        </TableCell>
                                        <TableCell>
                                            {moment(
                                                user?.metadata?.createDate?.toDate()
                                            ).format('DD/MM/YYYY')}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow hover>
                                    <TableCell colSpan={4}>
                                        <CircularProgress />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>
            </PerfectScrollbar>
            <Box display="flex" justifyContent="flex-end" p={2}>
                <Button
                    color="primary"
                    component={RouterLink}
                    endIcon={<ArrowRightIcon />}
                    size="small"
                    variant="text"
                    to="/app/users"
                >
                    View all
                </Button>
            </Box>
        </Card>
    )
}

LatestUsers.propTypes = {
    className: PropTypes.string
}

export default LatestUsers
